var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{key:_vm.menu_id,staticClass:"layout__body"},[_c('SubMenu',{attrs:{"items":_vm.get_menu_children(_vm.menu_id)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }